const translations = {
    classification: 'Classification',
    epaNumber: 'EPA Number',
    loading: 'Loading',
    manufacturer: 'Manufacturer',
    name: 'Name',
    noChemicals: 'No Chemicals',
    noMoreChemicals: 'No more chemicals',
    source: 'Source'
};

export default translations;
